'use es6';

import { ASSET_TYPE_TOKENS } from '../utilities/filterAssetTypeTokens';
import { EERIE, FLINT } from 'HubStyleTokens/colors';
import { CTA, IMPORT, IN_LIST } from '../filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import { getDynamicFilterFamilyBasis } from '../filterQueryFormat/DynamicFilterFamilies';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PropTypes from 'prop-types';
import UIIcon from 'UIComponents/icon/UIIcon';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RestrictedAssetContainer = styled.div.withConfig({
  displayName: "RestrictedAsset__RestrictedAssetContainer",
  componentId: "hgnyl-0"
})(["display:inline-block;cursor:not-allowed;color:", ";"], FLINT);
const getAssetTypeLabelToken = (filterFamily, isValue) => {
  if (filterFamily === CTA && isValue) {
    return 'CTA_VERSION';
  }
  if (getDynamicFilterFamilyBasis(filterFamily) === IMPORT) {
    return ASSET_TYPE_TOKENS[IMPORT];
  }
  if (getDynamicFilterFamilyBasis(filterFamily) === IN_LIST) {
    return ASSET_TYPE_TOKENS[IN_LIST];
  }
  return ASSET_TYPE_TOKENS[filterFamily];
};
const RestrictedAsset = ({
  filterFamily,
  filterDisplayElement
}) => {
  const assetTypeLabelToken = getAssetTypeLabelToken(filterFamily, filterDisplayElement === 'value');
  return /*#__PURE__*/_jsx(UITooltip, {
    placement: "right",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: 'customerDataFilters.restrictedAsset.tooltip'
    }),
    children: /*#__PURE__*/_jsxs(RestrictedAssetContainer, {
      children: ["\xA0", /*#__PURE__*/_jsx(UIIcon, {
        color: EERIE,
        name: "hide"
      }), "\xA0", /*#__PURE__*/_jsx(FormattedMessage, {
        message: `customerDataFilters.restrictedAsset.assetLabel.${assetTypeLabelToken}`
      })]
    })
  });
};
RestrictedAsset.propTypes = {
  filterDisplayElement: PropTypes.oneOf(['value', 'label']),
  filterFamily: PropTypes.string.isRequired
};

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
RestrictedAsset.defaultProps = {
  filterDisplayElement: 'label'
};
export default RestrictedAsset;